
import Vue from 'vue'
import { mergeData } from 'vue-functional-data-merge'

export default Vue.extend({
  name: 'WeveButtonGroup',
  functional: true,
  props: {
    tag: {
      type: String,
      default: 'div',
    },
    label: {
      type: String,
      required: true,
    },
  },
  render(h, { props, children, data }) {
    return h(
      props.tag,
      mergeData(data, {
        attrs: { role: 'group', 'aria-label': props.label },
        staticClass: 'weve-button-group',
      }),
      children,
    )
  },
})
